import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AppearanceState {
  darkModeEnabled: boolean;
}

// index.html's pre-paint script sets <html data-theme="dark"> from the stored
// JWT before the bundle loads. Seeding from it makes the first React render
// dark as well, instead of one light frame until useAppearanceSync's effect.
const initialState: AppearanceState = {
  darkModeEnabled:
    typeof document !== 'undefined' &&
    document.documentElement.getAttribute('data-theme') === 'dark',
};

const appearanceSlice = createSlice({
  name: 'appearance',
  initialState,
  reducers: {
    setDarkModeEnabled: (state, action: PayloadAction<boolean>) => {
      state.darkModeEnabled = action.payload;
    },
  },
});

export const { setDarkModeEnabled } = appearanceSlice.actions;
export default appearanceSlice.reducer;
